class UserModalController {

    constructor(
        PreRegisterModalService,
        UserHelper
    ) {
        'ngInject'

        this.PreRegisterModalService = PreRegisterModalService;
        this.UserHelper = UserHelper;
    }

    $onInit() {
        this.clientList = this.resolve.clientList;
        this.roleList = this.resolve.roleList.filter(role => role.name != 'Custom')
        this.itemsPerPage = 5;

        this.roleOption = undefined;

        this.canViewAllClients = false;
        this.canViewAllPhysicalTherapyClients = false;
        this.selectedClients = [];
        this.clientIds = [];
        this.email = '';
    }

    selectRole(role) {
        this.roleOption = role;
    }

    addClient(client) {
        if (this.clientIds.indexOf(client.id) === -1) {
            if (client.isRemoved) {
                this.toggleClient(client)
            }
            else {
                this.selectedClients.push(client);
                this.clientIds.push(client.id);
            }
        }

    }

    /***
     * If no clients are selected (either by selection or one of the ViewAlls), return True to keep form invalid
     */
    noClientSelected() {
        return (this.clientIds.length == 0 && !this.canViewAllClients && !this.canViewAllPhysicalTherapyClients);
    }

    closeModal() {
        this.modalInstance.close();
        this.resolve.parentController.hideError();
    }

    saveModal() {
        const permissions = {
            VIEW_ALL_CLIENTS: this.canViewAllClients,
            VIEW_PT_CLIENTS: this.canViewAllPhysicalTherapyClients
        };
        const customPermissions = this.UserHelper.getConditionalPermissionIds(permissions);

        this.PreRegisterModalService.preRegisterUser(this.email,
                                                     this.roleOption.id,
                                                     this.clientIds,
                                                     customPermissions)
            .then((successResponse) => {
                this.resolve.parentController.updateUserList();
                this.resolve.parentController.hideError();
                this.modalInstance.close();
            }, (errorResponse) => {
                this.resolve.parentController.showErrorMessage(errorResponse.data.error_msg);
            })
    }

    toggleClient(client) {
        const clientIdIndex = this.clientIds.indexOf(client.id);
        if (clientIdIndex > -1) {
            client.isRemoved = true;
            this.clientIds.splice(clientIdIndex, 1);
        }
        else {
            this.clientIds.push(client.id);
            client.isRemoved = false;
        }
    }

    updatePaginationStartingIndex(startingIndex) {
        this.startingIndex = startingIndex;
    }

}

export default UserModalController;


// WEBPACK FOOTER //
// ./app/components/user-admin/pre-register-modal/pre-register-modal-controller.js